var map = {
	"./gift_10.webp": 61684,
	"./gift_100.webp": 46612,
	"./gift_25.webp": 21936,
	"./gift_250.webp": 33384,
	"./gift_3.webp": 7094,
	"./gift_5.webp": 69144,
	"./gift_50.webp": 45024,
	"./gift_500.webp": 75512
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16164;